import React from "react";

const features = [
  { icon: "icon-01.svg", title: "Local City Rides", bg: "" },
  { icon: "icon-02.svg", title: "Airport Transfers", bg: "bg-2" },
  { icon: "icon-3.svg", title: "Outstation Trips", bg: "bg-3" },
  { icon: "icon-4.svg", title: "Corporate Travel", bg: "bg-4" },
  { icon: "icon-5.svg", title: "Wedding & Event Cabs", bg: "bg-5" },
  { icon: "icon-6.svg", title: "Long Distance Travel", bg: "bg-6" },
  { icon: "icon-7.svg", title: "24x7 Cab Service", bg: "bg-7" },
  { icon: "icon-8.svg", title: "Luxury & Group Travel", bg: "bg-8" },
];

const TopService = () => {

  const handleWhatsApp = () => {
    const phone = "919529877342";
    const msg = "Hello, I want to book a cab from Royal Route Cab.";
    window.open(`https://wa.me/${phone}?text=${encodeURIComponent(msg)}`);
  };

  return (
    <section className="top-destination-section-4 section-padding pb-0">
      <div className="container">

        {/* Section Header */}
        <div className="section-title-area">
          <div className="section-title">
            <span className="wow fadeInUp">Royal Route Cab Services</span>

            <h2 className="wow fadeInUp" data-wow-delay=".3s">
              Reliable Cab Services for Every Journey
            </h2>

            <p className="mt-3 wow fadeInUp" data-wow-delay=".3s">
              We provide safe, comfortable, and affordable cab services including
              local rides, airport transfers, outstation trips, and corporate travel.
              Our goal is to make every journey smooth and stress-free.
            </p>
          </div>
        </div>

        {/* Features Grid */}
        <div className="row">
          {features.map((item, index) => (
            <div
              key={index}
              className="col-xl-3 col-lg-4 col-md-6 wow fadeInUp"
              data-wow-delay={`.${2 + index * 2}s`}
            >
              <div className="destination-feature-box">

                {/* SAME IMAGE PATH */}
                <div className={`icon ${item.bg}`}>
                  <img
                    src={`/img/${item.icon}`}
                    alt={item.title}
                  />
                </div>

                <div className="content">
                  <h6>{item.title}</h6>
                  <span>
                    Safe • Reliable • 24x7 Available
                  </span>
                </div>

              </div>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div
          className="cta-wrapper-4 section-padding bg-cover"
          style={{
            backgroundImage: "url(/img/cta/cta-bg-3.jpg)",
          }}
        >
          <div className="section-title text-center mb-0">
            <span className="wow fadeInUp">Royal Route Cab</span>

            <h2 className="text-white wow fadeInUp" data-wow-delay=".3s">
              Experience Safe, Reliable & Comfortable Travel <br />
              With Professional Cab Services
            </h2>

            <p className="text-white mt-3 wow fadeInUp" data-wow-delay=".5s">
              Whether it's daily travel, airport transfers, or outstation trips,
              we ensure every ride is punctual, secure, and comfortable.
            </p>
          </div>

          <button
            onClick={handleWhatsApp}
            className="theme-btn wow fadeInUp"
            data-wow-delay=".5s"
          >
            <span>Book Your Ride</span>{" "}
           <i className="fas fa-long-arrow-right"></i>
          </button>

          {/* SAME DECORATIVE IMAGES */}
          {/* <div className="discount-shape float-bob-y">
            <img src="/img/cta/discount.png" alt="shape" />
          </div> */}

          <div className="bag-shape float-bob-x">
            <img src="/img/cta/bag.png" alt="shape" />
          </div>

          <div className="plane-shape">
            <img src="/img/cta/olane-shape.png" alt="shape" />
          </div>
        </div>

      </div>
    </section>
  );
};

export default TopService;